export const setProductConfigForAPPDP = function(productConfig){
    window.productConfigForPDP = productConfig;
    window.dataLayer.push({
        event:'productConfig',
        productConfig
    });
}

window.setProductConfigForAPPDP = setProductConfigForAPPDP;


// WEBPACK FOOTER //
// ./src/Common/Editor/pdpProductConfigProvider.js